import {Component, Inject, Input, OnInit} from '@angular/core';
import { ListService } from '@app/common/services/list.service';

import { AuthService } from '@app/common/services/auth.service';
import { DocumentModel } from '@app/common/models/document.model';
import { Restangular } from 'ngx-restangular';
import * as _ from 'lodash';
import { PageableListService } from '@app/common/services/pageable.list.service';
import {DialogService} from "@app/common/services/dialog.service";
import {StateService, Transition, TransitionService} from "@uirouter/angular";
import {ErrorHandlerService} from "@app/common/services/error-handler.service";
import {ComponentModel} from "@app/common/models/component.model";
import {FolderModel} from "@app/common/models/folder.model";
import {ComponentEditComponent} from "@app/ps/components/component-edit/component-edit.component";
import {ClassName} from "@app/common/enums/class-name.enum";
import {AttachmentTypeModel} from "@app/common/models/attachment-type.model";
import {AttachmentTypePipe} from "@app/common/pipes/attachment-type.pipe";

@Component({
  selector: 'document-classification',
  templateUrl: './document-classification.component.html',
  styleUrls: ['document-classification.component.scss']
})
export class DocumentClassificationComponent implements OnInit {

  @Input() documentId: number;
  document: DocumentModel;
  loading = true;
  selectedEntity: any;
  restBaseUrl: string;
  authToken: string;
  attachmentTypes: AttachmentTypeModel[];
  assignedAttachmentTypes = {};

  entityTabs: any[] = [
    {
      value: 'Případy',
      id: 'cases',
      uiSref: 'symap.project.cases.detail',
      uiParams: { },
      uiIdField: 'id',
      endpoint: 'cases',
      columns: ['folderNumber', 'caseNumber', 'areaName', 'lv', 'owner', 'caseType', 'caseStatus', 'respectiveDate', 'constructionObjects', 'price'],
      defaultFilter: {
        filters: {
          loadCollections: [
            'titles',
            'caseOwnerships',
            'constructionObjects',
            'caseSubjects',
            'folder'
          ],
          cancelStatus: {values: [{id: 'notCancelled'}]},
          searchText: {values: [{id: ''}]},
        }
      },
    },
    {
      value: 'Vlastníci',
      id: 'subjects',
      uiSref: 'symap.project.owners.detail',
      uiParams: {},
      uiIdField: 'ownerId',
      endpoint: 'subjects',
      defaultFilter: {
        filters: {
          loadCollections: ['ownerships', 'occupationResolution'],
          searchText: {values: [{id: ''}]},
          validity: {values: ['withOccupationOrEasement', 'invalidWithCase']},
          opsubType: {values: [{id: 'BSM'}], negation: true},
        }
      },
    },
    {
      value: 'Parcely',
      id: 'parcels',
      uiSref: 'symap.project.parcels.detail',
      uiParams: { },
      uiIdField: 'id',
      endpoint: 'parcels',
      defaultFilter: {
        filters: {
          validity: 'valid',
          searchText: { values: [{ id: '' }]},
          loadCollections: [
            'title.ownerships',
            'geometricPlanRequests',
            'opinionRequests',
            'constructionObjects',
            'knBudoucPepvs',
            'parcelPrices'
          ]
        }
      },
    },
    {
      value: 'Listy vlastnictví',
      id: 'titles',
      uiSref: 'symap.project.titles.detail',
      uiParams: { },
      uiIdField: 'id',
      endpoint: 'titles',
      columns: ['lv', 'areaName', 'owner', 'case', 'pernamentOccupationState', 'overOneYearOccupationState', 'underOneYearOccupationState', 'easementCaseState', 'blocked'],
      defaultFilter: {
        filters: {
          validity: 'valid',
          searchText: {values: [{id: ''}]},
          loadCollections: [
            'ownerships',
            'occupationResolution',
            'duplicityOwnership'
          ],
        }
      },
    },
    {
      value: 'GP',
      id: 'geometricPlans',
      uiSref: 'symap.project.geometricPlanRequests.detail',
      uiParams: { },
      uiIdField: 'id',
      endpoint: 'geometric-plan-requests',
      defaultFilter: {
        filters: {
          deleted: { values: [ false ] },
          searchText: { values: [{ id: '' }]},
          loadCollections: ['areas', 'constructionObjects', 'parcels', 'folder']
        }
      },
    },
    {
      value: 'ZP',
      id: 'opinions',
      uiSref: 'symap.project.opinionRequests.detail',
      uiParams: {  },
      uiIdField: 'id',
      endpoint: 'opinion-requests',
      defaultFilter: {
        filters: {
          deleted: { values: [ false ] },
          searchText: { values: [{ id: '' }]},
          loadCollections: ['areas', 'constructionObjects', 'parcels', 'folder']
        }
      },
    },
    {
      value: 'SO',
      id: 'constructionObjects',
      uiSref: 'symap.project.constructionObjects.detail',
      uiParams: {  },
      uiIdField: 'id',
      endpoint: 'construction-objects',
      defaultFilter: {
        filters: {
          validity: 'valid',
          searchText: { values: [{ id: '' }]},
          loadCollections: ['occupationResolution']
        }
      },
    },
  ];

  constructor(
    private pageableListService: PageableListService,
    private restangular: Restangular,
    public authService: AuthService,
    public listService: ListService,
    private dialogService: DialogService,
    private stateService: StateService,
    private errorHandlerService: ErrorHandlerService,
    @Inject('$transition$') private transition: Transition,
    public attachmentTypePipe: AttachmentTypePipe
  ) {
    this.onItemSelect = this.onItemSelect.bind(this);
    this.onPageChanged = this.onPageChanged.bind(this);
    this.onUpdateComponent = this.onUpdateComponent.bind(this);
    this.onAssignAttachmentType = this.onAssignAttachmentType.bind(this);
  }

  async ngOnInit() {
    this.restBaseUrl = this.authService.getActiveApplicationRestUrl();
    this.authToken = this.authService.getToken();
    this.attachmentTypes = _.cloneDeep(AttachmentTypeModel.getByCategory('component'))
      .filter(a => !['CONTRACT_EXTERNAL', 'COVERING_LETTER_EXTERNAL'].includes(a.id));

    await this.loadDocument();

    for (const component of this.document.components) {
      this.assignedAttachmentTypes[component.id] = component.attachmentType
        ? AttachmentTypeModel.createById(component.attachmentType)
        : undefined;
    }
    this.onChangeEntity('cases');
    this.loading = false;
  }

  loadDocument(): Promise<Document> {
    return this.restangular
      .one('documents', this.documentId)
      .customGET('', { loadCollections: ['components'] })
      .toPromise()
      .then(data => {
        this.document = data.plain();
      });
  }

  onChangeEntity(entityId: string) {
    const selectedEntity = _.find(this.entityTabs, { id: entityId });

    if (!selectedEntity.list) {
      selectedEntity.pageableList = this.pageableListService.get(
        selectedEntity.endpoint,
        selectedEntity.defaultFilter,
        undefined,
        this.restangular
      );
      selectedEntity.list = selectedEntity.pageableList.list;
      this.selectedEntity = selectedEntity;
    } else {
      this.selectedEntity = selectedEntity;
    }
  }

  onPageChanged(event) {
    this.selectedEntity.pageableList.fetchResults(event);
  }

  onItemSelect(entity: any, type?: string) {
    if (!this.document.components.every(c => !!c.attachmentType)) {
      this.dialogService.alertDialogPromise('Před zařazením je potřeba všem komponentám dokumentu nastavit typ.');
    } else {
      this.dialogService.confirmDialogPromise('Opravdu chcete zařadit dokument?')
        .then((data) => {
          if (data === true) {
            const documentRelation = {};

            if (type) {
              documentRelation[type + 'Id'] = entity.id;
            }

            this.restangular.one('documents', this.document.id).customPOST(documentRelation, 'classify')
              .toPromise()
              .then(() => {
                const params = { tab: 'documents-epd' };
                if (entity.id) {
                  params[this.selectedEntity.uiIdField] = entity.id;
                  this.stateService.go(this.selectedEntity.uiSref, params);
                } else {
                  this.stateService.go('symap.project.info', params);
                }
              }, this.errorHandlerService.get);
          }
        });
    }
  }

  onUpdateComponent(component: ComponentModel) {
    const dialog = this.dialogService.open(ComponentEditComponent, {
      data: { component: component },
      className: ClassName.HIGHER_DIALOG,
    });

    const sub = dialog.afterClosed.subscribe((result: ComponentModel | boolean) => {
      if (result) {
        this.restangular.one('documents', component.document.id).one('components', component.id).customPOST(result, 'update').toPromise();
      }
      sub.unsubscribe();
    });
  }

  onAssignAttachmentType(component: ComponentModel, attachmentType: AttachmentTypeModel) {
    component.attachmentType = attachmentType ? attachmentType.id : undefined;

    this.restangular.one('documents', component.document.id).one('components', component.id)
      .customPOST(component, 'update')
      .toPromise();
  }

  canEdit() {
    return this.authService.hasPermission('admin');
  }

  onBack() {
    const fromState = this.transition.from();
    const fromParams = this.transition.params('from');
    this.stateService.go(fromState.name, fromParams);
  }
}
